import "core-js/features/array/find";
import "core-js/features/array/find-index";
import "core-js/features/array/from";
import "core-js/features/array/includes";
import "core-js/features/object/assign";
import "core-js/features/string/starts-with";
import "core-js/features/string/ends-with";
import "core-js/features/string/includes";
import "core-js/features/promise";
import "core-js/features/url/";
import "core-js/features/url-search-params";
import "core-js/features/object/values";
import fetch from "unfetch";

if (!window.fetch) {
    (window as any).fetch = fetch;
}

console.log("[RVS] Loaded polyfills for Valu Search v" + process.env.VERSION);
